import React, { useState } from 'react';

const ContactPage: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
        <div className="py-20 animate-fadeIn">
            <div className="container mx-auto px-4 text-center max-w-2xl">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-[#05F564] mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h1 className="mt-4 text-4xl font-extrabold text-slate-900 dark:text-white">Thank You!</h1>
                <p className="mt-4 text-lg text-slate-600 dark:text-zinc-300">
                    Your message has been sent successfully. Our team will get back to you within 24 hours.
                </p>
            </div>
        </div>
    )
  }

  return (
    <div className="py-20 animate-fadeIn">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white">Get in Touch</h1>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-slate-600 dark:text-zinc-300">
            We'd love to hear from you. Whether you have a question about features, pricing, or anything else, our team is ready to answer all your questions.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-0 glass-effect rounded-2xl overflow-hidden border border-slate-200 dark:border-zinc-800 shadow-lg">
          <div className="bg-slate-50 dark:bg-black/50 p-8 md:p-10">
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Contact Information</h2>
            <div className="mt-6 space-y-6">
              <div className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#05F564]" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                <span className="ml-4 text-slate-600 dark:text-zinc-300">support@wampia.com.ng</span>
              </div>
              <div className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#05F564]" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                <span className="ml-4 text-slate-600 dark:text-zinc-300">+2349131985866</span>
              </div>
              <div className="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#05F564] mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                <span className="ml-4 text-slate-600 dark:text-zinc-300">Lagos, Nigeria</span>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6 p-8 md:p-10">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-slate-700 dark:text-zinc-300">Full Name</label>
              <input type="text" id="name" required className="mt-1 block w-full px-3 py-2 bg-white dark:bg-zinc-800 border border-slate-300 dark:border-zinc-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#05F564] focus:border-[#05F564] text-slate-900 dark:text-zinc-100 dark:placeholder-zinc-400" />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-slate-700 dark:text-zinc-300">Email Address</label>
              <input type="email" id="email" required className="mt-1 block w-full px-3 py-2 bg-white dark:bg-zinc-800 border border-slate-300 dark:border-zinc-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#05F564] focus:border-[#05F564] text-slate-900 dark:text-zinc-100 dark:placeholder-zinc-400" />
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-slate-700 dark:text-zinc-300">Message</label>
              <textarea id="message" rows={4} required className="mt-1 block w-full px-3 py-2 bg-white dark:bg-zinc-800 border border-slate-300 dark:border-zinc-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#05F564] focus:border-[#05F564] text-slate-900 dark:text-zinc-100 dark:placeholder-zinc-400"></textarea>
            </div>
            <div>
              <button type="submit" className="w-full bg-[#05F564] text-black font-bold py-3 px-4 rounded-lg shadow-md hover:bg-[#04d458] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-100 dark:focus:ring-offset-black focus:ring-[#05F564]">
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;